import { render } from "./edit-profile.vue?vue&type=template&id=ef403592&scoped=true"
import script from "./edit-profile.vue?vue&type=script&lang=js"
export * from "./edit-profile.vue?vue&type=script&lang=js"

import "../../resources/css/settings.scss?vue&type=style&index=0&id=ef403592&lang=scss&scoped=true&external"
import "./edit-profile.vue?vue&type=style&index=1&id=ef403592&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef403592"]])

export default __exports__